export default __webpack_public_path__ + "static/media/exterior3_2020.831cf0eb.jpeg";